import { type SelectionsMachine } from '../../machine/selection-machine.ts';
import { type SelectionInput } from '../types.ts';

/**
 * A simple input that subscribes to view state changes and dispatches a deselect all
 * to nuke the selections when relevant changes happen.
 */
export function createViewChangesInput(
  machine: SelectionsMachine,
  subscribe: (onChange: VoidFunction) => VoidFunction
): SelectionInput {
  let unsubscribe: VoidFunction | null;

  return {
    setup() {
      unsubscribe = subscribe(() => {
        machine.dispatch({
          type: 'deselectAll',
          source: 'api'
        });
      });
    },

    dispose() {
      unsubscribe?.();
    }
  };
}
